import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AdminOrganizationUser } from 'src/app/admin/models/organization.model';

const BASE_URL = `${environment.apiOrg.url}/admin`;

@Injectable()
export class UserSearchService {
  constructor(private http: HttpClient) {}

  loadUsersByEmail(email: string): Observable<AdminOrganizationUser> {
    const url = `${BASE_URL}/users/by-email?email=${encodeURIComponent(email)}`;
    return this.http.get<AdminOrganizationUser>(url);
  }
}
